import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { getPatientPharmaciesApi } from "./getPatientPharmaciesApi";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

export interface PharmacyDeleteErrorResponse {
  detail: string;
}

export const useDeletePatientPharmacy = (
  handleCloseModal: () => void,
  handleError: (value: AxiosError<PharmacyDeleteErrorResponse>) => void,
  patientId?: string,
) => {
  const queryClient = useQueryClient();
  const api = getPatientPharmaciesApi(patientId);

  const { mutate: deletePharmacy, isPending } = useMutation({
    mutationFn: (pharmacyId: string) => api.deletePharmacy(pharmacyId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: patientPharmaciesQueryKey(patientId),
      });
      handleCloseModal();
    },
    onError: (error: AxiosError<PharmacyDeleteErrorResponse>) => {
      handleError(error);
    },
  });

  return { deletePharmacy, isPending };
};
